/* eslint-disable no-unused-expressions */
import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { EDeviceType } from '../../types/device';
import * as styles from './ResultsEmpty.css';
import classNames from 'classnames';

const heartIcon = require('./img/heart.svg');

export interface IResultsEmptyStoreProps {
  isAuthenticated: boolean;
  deviceType: EDeviceType;
  onClickSearch(): void;
}

export type TResultsEmptyProps = IResultsEmptyStoreProps;

export function ResultsEmptyFolder({ isAuthenticated, deviceType, onClickSearch }: IResultsEmptyStoreProps) {
  return (
    <div className={styles['container']}>
      <div className={classNames(styles['wrapper'], styles['wrapper-folder'])}>
        <div className={styles['empty-background']} />
        <div className={styles['title']}>
          <span>В подборке нет объявлений</span>
        </div>
        <div className={styles['description']}>
          Сохраняйте объявления в подборки, нажимая на <img className={styles['icon']} src={heartIcon} /> в поиске️, а
          затем на кнопку «Сохранить в подборку» в появившемся ниже уведомлении
        </div>
        <Button size={deviceType === EDeviceType.Desktop ? 'XS' : 'M'} theme="fill_primary" onClick={onClickSearch}>
          {isAuthenticated ? 'Искать объявления' : 'Войти'}
        </Button>
      </div>
    </div>
  );
}
